import axios from '../../api-client.ts';
import { useEffect, useState } from 'react';
import { useLoaderData, useParams } from 'react-router';
import LoadingSpinner from '../../../_mesomb/partials/components/LoadingSpinner.tsx';
import { AppConfig, CheckoutSessionModel } from '../../../types';
import CheckoutPayment from './components/CheckoutPayment.tsx';

const CheckoutPaymentPage = () => {
  const { key } = useParams();
  const { configs } = useLoaderData<{ configs: AppConfig }>();
  const [loading, setLoading] = useState<boolean>(true);
  const [session, setSession] = useState<CheckoutSessionModel | undefined>(undefined);

  useEffect(() => {
    axios
      .get<CheckoutSessionModel>(`/internal/checkout/sessions/${key}/`)
      .then((response) => {
        setLoading(false);
        setSession(response.data);
      })
      .catch(() => {
        setLoading(false);
        setSession(undefined);
      });
  }, []);

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div className='d-flex flex-column flex-root'>
      <div className='d-flex flex-column flex-center flex-column-fluid'>
        <div className='d-flex flex-column p-10'>
          <CheckoutPayment session={session} configs={configs} />
        </div>
      </div>
    </div>
  );
};

export default CheckoutPaymentPage;
